const isInternetExplorer = () => {
    //https://stackoverflow.com/a/19999868
    return !!(
        window &&
        window.navigator &&
        window.navigator.userAgent &&
        window.navigator.userAgent.match(/Trident.*rv\:11\./)
    );
};

export {
    isInternetExplorer
}